import { type Key, useEffect } from 'react'
import SeeAllBtn from '../SeeAll'

import { TableContainer, Table, TableBody, TableRow, TableCell, Paper, Typography, Box, useMediaQuery } from '@mui/material'
import { styled, useTheme } from '@mui/material/styles'
import { useGetLeadsMutation } from '../../redux/api/ihfApi'
import { useSelector } from 'react-redux'
import { type ILead } from '../../redux/api/types'

const shapeStyles = { width: 30, height: 30 }
const shapeCircleStyles = { color: '#FFF', fontSize: '15px', borderRadius: '20%', display: 'flex', justifyContent: 'center', alignItems: 'center' }

const ThinTableCell = styled(TableCell)(({ theme }) => ({
  padding: '4px 0'
}))

function getLeadsMethod () {
  const [getLeads] = useGetLeadsMutation()
  useEffect(() => {
    getLeads({ count: 7 })
      .then(() => {})
      .catch(() => {})
  }, [])

  const ihfState = useSelector((state: any) => state.ihfState)
  const { leads } = ihfState
  return leads
}

interface IRecentLeads {
  openIHFDashboard: () => void
  isLoadingIHFLink: boolean
}

const RecentLeads = ({ openIHFDashboard, isLoadingIHFLink }: IRecentLeads) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.only('xs'))
  const leads = getLeadsMethod()
  return (
    <Paper sx={{ padding: '17px 24px 32px', boxShadow: 0, height: '100%', maxHeight: '407px' }}>
      <Box sx={{ display: 'flex', width: '100%', alignItems: 'center', mb: '4px', height: '30px' }}>
        <Typography
          sx={{ color: theme.palette.grey[40] }}
          variant='caption'
        >
          Recent Leads
        </Typography>
        <SeeAllBtn onClick={openIHFDashboard} isDisable={isLoadingIHFLink} />
      </Box>
      <TableContainer>
        <Table sx={{ minWidth: isMobile ? '380px' : '500px' }} aria-label="Monthly Activity">
          <TableBody>
            {leads?.length > 0 && <TableRow>
              <ThinTableCell>
                <Box sx={{ color: '#99A6BF', fontWeight: 700 }}>
                  Name
                </Box>
              </ThinTableCell>
              <ThinTableCell />
              <ThinTableCell>
                <Box sx={{ color: '#99A6BF', fontWeight: 700 }}>
                  Date
                </Box>
              </ThinTableCell>
              <ThinTableCell>
                <Box sx={{ color: '#99A6BF', fontWeight: 700, textAlign: 'center' }}>
                  Source
                </Box>
              </ThinTableCell>
              <ThinTableCell>
                <Box sx={{ color: '#99A6BF', fontWeight: 700, textAlign: 'center' }}>
                  Phone
                </Box>
              </ThinTableCell>
            </TableRow>}
          {leads?.map((item: ILead, index: Key | null | undefined) => {
            const { firstName, lastName, createdOn, source, phone } = item
            const dateOptions: Intl.DateTimeFormatOptions = {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            }
            return (
              <TableRow
                key={index}
                sx={{ '& td, & th': { border: 0 } }}
              >
                <ThinTableCell>
                  <Box sx={{ ...shapeStyles, ...shapeCircleStyles, bgcolor: 'Lavender' }}>
                    {firstName ? firstName[0].toUpperCase() : lastName ? lastName[0].toUpperCase() : ''}
                  </Box>
                </ThinTableCell>
                <ThinTableCell sx={{ pl: 1, minWidth: isMobile ? '80px' : '80px' }}>{(String(firstName) + ' ' + String(lastName)).trim() ?? '-'}</ThinTableCell>
                <ThinTableCell sx={{ color: '#7D8FB3' }}>{createdOn ? new Date(createdOn).toLocaleDateString('en-US', dateOptions) : '-'}</ThinTableCell>
                <ThinTableCell align="center" sx={{ color: '#7D8FB3' }}>{source ?? '-'}</ThinTableCell>
                <ThinTableCell align="center" sx={{ color: '#7D8FB3' }}>{phone ?? '-'}</ThinTableCell>
              </TableRow>
            )
          })}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  )
}

export default RecentLeads
